import { useState } from "react";
import { Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { faClose, faExpandAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const TAMANHO_MAXIMO_COLUNA = 40;

const PopupTexto = ({ texto, titulo, sempreLink = false }) => {
    const [openPopup, setOpenPopup] = useState(false);

    if (!texto) return "-";

    const textoLongo = texto.length > TAMANHO_MAXIMO_COLUNA;

    const mostraLink = sempreLink || textoLongo;

    return (
        <>
            {mostraLink ? (
                <span style={{ cursor: "pointer", color: "#90caf9", textDecoration: "underline" }} onClick={() => setOpenPopup(true)}>
                    <FontAwesomeIcon icon={faExpandAlt} style={{ marginRight: 6, fontSize: "0.8rem" }} />
                    {titulo ?? "texto"}
                </span>
            ) : (
                texto
            )}

            <Dialog open={openPopup} onClose={() => setOpenPopup(false)} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ backgroundColor: "#232323", color: "white", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <span>{titulo ?? "Texto"}</span>
                    <Button onClick={() => setOpenPopup(false)} sx={{ color: "white", minWidth: "auto" }}>
                        <FontAwesomeIcon icon={faClose} />
                    </Button>
                </DialogTitle>
                <DialogContent sx={{ backgroundColor: "#232323", color: "#e0e0e0", whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                    {texto}
                </DialogContent>
            </Dialog>
        </>
    );
};

export { PopupTexto };